// Float-safe numeric comparison. Backend FloatFields computed via different
// arithmetic paths can differ by float noise (~1e-13) for mathematically-equal
// values; compare below the data's 6-decimal precision so effectively-equal
// amounts are treated as equal (default epsilon 1e-7).
const DEFAULT_EPSILON = 1e-7

export const useNumberComparison = (epsilon = DEFAULT_EPSILON) => {
  const toNumber = (val) => Number(val) || 0

  const areEqual = (a, b) => Math.abs(toNumber(a) - toNumber(b)) < epsilon
  const isGreater = (a, b) => toNumber(a) - toNumber(b) >= epsilon
  const isLess = (a, b) => toNumber(b) - toNumber(a) >= epsilon
  const compare = (a, b) => (areEqual(a, b) ? 0 : (toNumber(a) > toNumber(b) ? 1 : -1))

  return { epsilon, areEqual, isGreater, isLess, compare }
}
